import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Logo } from "@/components/Logo";
import { Heart, ShieldCheck, Users, Sparkles } from "lucide-react";

const VALUES = [
  { icon: Heart, title: "Marriage, not dating", body: "A serious, intention-first platform built for those seeking a spouse — not casual chats." },
  { icon: ShieldCheck, title: "Privacy by design", body: "No public browsing of your contact details. They're revealed only after a mutual match, on the channels you choose." },
  { icon: Users, title: "Family involved", body: "Invite a Wali or guardian to review your matches respectfully, the way it should be." },
  { icon: Sparkles, title: "Guided by values", body: "Compatibility built around character, faith and shared goals — with AI help when you want it." },
];

export default function About() {
  const [info, setInfo] = useState({});
  useEffect(() => { api.get("/faq").then(({ data }) => setInfo(data)).catch(() => {}); }, []);

  return (
    <div className="mx-auto max-w-2xl" data-testid="about-page">
      <div className="rounded-3xl bg-gradient-to-br from-emerald-800 to-emerald-950 p-8 text-center text-white">
        <div className="mx-auto mb-4 w-fit"><Logo size="lg" dark /></div>
        <h1 className="font-serif text-3xl font-bold sm:text-4xl">About Nikah Match</h1>
        <p className="mx-auto mt-3 max-w-md text-emerald-100/90">A modern, privacy-first way to find a spouse — rooted in respect, family involvement and shared values.</p>
      </div>

      <div className="mt-6 grid gap-4 sm:grid-cols-2" data-testid="about-values">
        {VALUES.map(({ icon: Icon, title, body }) => (
          <div key={title} className="rounded-2xl border border-emerald-900/10 bg-white p-5">
            <Icon className="h-6 w-6 text-emerald-700" />
            <p className="mt-2 font-semibold text-emerald-900">{title}</p>
            <p className="mt-1 text-sm text-slate-600">{body}</p>
          </div>
        ))}
      </div>

      <div className="mt-6 rounded-2xl bg-mint/40 p-5 text-center text-sm text-emerald-900/80" data-testid="about-company">
        <p>{info.company || "Horizon Grid LLC"}</p>
        {info.supportEmail && <a href={`mailto:${info.supportEmail}`} className="font-medium text-emerald-700 hover:underline">{info.supportEmail}</a>}
        <div className="mt-3 flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-slate-500">
          <Link to="/privacy" className="hover:text-emerald-700">Privacy</Link>
          <Link to="/terms" className="hover:text-emerald-700">Terms</Link>
          <Link to="/community" className="hover:text-emerald-700">Community Guidelines</Link>
        </div>
      </div>
    </div>
  );
}
